import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { errorHelper, Loader, isSubscriptionActive, shouldShowPaymentAlert } from '../../utils/tools';
import PaymentAlert from '../../utils/paymentAlert';
import PlanLimitAlert from '../../utils/planLimitAlert';

import { fetchBranches, deleteBranch } from '../../store/actions/branch';
import { getTenant } from '../../store/actions/tenant';

import { PLAN_LIMITS } from '../../config/plans';

import AddBranch from './add';
import EditBranch from './edit';
import CustomModal from '../../hoc/customModal';

import { Button, Table, OverlayTrigger, Tooltip, Modal } from 'react-bootstrap';

// Assets
import { ReactComponent as EditIcon } from '../../assets/edit.svg';
import { ReactComponent as RemoveIcon } from '../../assets/remove.svg';

const ShowBranches = () => {
    const branches = useSelector(state => state.branch.data);
    const branchId = useSelector(state => state.branch.current);
    const loading = useSelector(state => state.branch.loading);
    const editedBranch = useSelector(state => state.branch.editedBranch);
    const tenant = useSelector(state => state.tenant.current);

    const planLimits = PLAN_LIMITS[tenant.plan];
    const isActive = isSubscriptionActive(tenant?.subscriptionStatus, tenant?.plan);
    const isAtLimit = !!(tenant && Array.isArray(tenant.branch) && tenant.branch.length >= planLimits?.maxBranches);

    let navigate = useNavigate();

    // Redux logic
    const dispatch = useDispatch();

    // Custom modal state
    const [isAddModalVisible, setIsAddModalVisible] = useState(false);
    const [isEditModalVisible, setIsEditModalVisible] = useState(false);
    const [show, setShow] = useState(false);
    const [branchToEdit, setBranchToEdit] = useState(null);
    const [branchIdToDelete, setBranchIdToDelete] = useState(null);
    const [branchNameToDelete, setBranchNameToDelete] = useState(null);

    // Handlers
    const handleCloseAddModal = () => {
        setIsAddModalVisible(false);
    };

    const handleAddClientButton = () => {
        setIsAddModalVisible(true);
    }

    const handleEditButtonClick = (branchId) => {
        setBranchToEdit(null);
        setBranchToEdit(branchId);
        setIsEditModalVisible(true);
    };

    const handleRemoveButtonClick = (branchId, branchName) => {
        setBranchIdToDelete(branchId);
        setBranchNameToDelete(branchName);
        handleShow();
    }

    const handleDeleteBranch = () => {
        dispatch(deleteBranch(branchIdToDelete)).then(() => {
                dispatch(fetchBranches());
                dispatch(getTenant(branchId));
        })
        .catch(error => {
            console.error("Error adding branch:", error);
        });
        handleClose();
    }

    const handleCloseEditModal = () => {
        setIsEditModalVisible(false);
        setBranchToEdit(null);
    };

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
            dispatch(fetchBranches());
    }, [dispatch, editedBranch]);

    // Render Tooltips
    const renderTooltipEdit = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Upraviť prevádzku
        </Tooltip>
    );

    const renderTooltipRemove = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Vymazať prevádzku
        </Tooltip>
    );

    const renderTooltipCannotRemoveLastBranch = () => (
        <Tooltip id="tooltip-disabled">
            Nemôžete vymazať poslednú prevádzku!
        </Tooltip>
    );
    
    const renderTooltipCannotRemoveWithEvidence = () => (
        <Tooltip id="tooltip-disabled">
            Nemôžete vymazať prevádzku, pokiaľ obsahuje evidenčné listy! 
        </Tooltip>
    );

    const renderTooltipCannotRemoveWithWarehouse = () => (
        <Tooltip id="tooltip-disabled">
            Nemôžete vymazať prevádzku, pokiaľ obsahuje sklady!
        </Tooltip>
    );

    const renderTooltipCannotRemoveWithContainer = () => (
        <Tooltip id="tooltip-disabled">
            Nemôžete vymazať prevádzku, pokiaľ obsahuje nádoby!
        </Tooltip>
    );

    return(
        <>
            { loading ?
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '35vh' 
                }}>
                    <Loader/>
                </div>
                : 
                <div>
                    
                    <Button
                        className="button-custom-large radius"
                        onClick={handleAddClientButton}
                        disabled={tenant && Array.isArray(tenant.branch) && tenant.branch.length >= planLimits.maxBranches || !isActive}
                    >
                        Pridať prevádzku
                    </Button>

                    {tenant && Array.isArray(tenant.branch) && tenant.branch.length >= planLimits.maxBranches && (
                        <PlanLimitAlert
                            current={tenant.branch.length}
                            max={planLimits.maxBranches}
                            label="prevádzok"
                            plan={tenant.plan}
                        />
                    )}

                    {tenant && !isAtLimit && shouldShowPaymentAlert(tenant.subscriptionStatus, tenant.plan) && (
                        <PaymentAlert status={tenant.subscriptionStatus} plan={tenant.plan} />
                    )}

                    <div className="content pt-4 pb-4">
                        <Table responsive hover>
                            <thead>
                                <tr>
                                    <th className="px-3">Názov prevádzky</th>
                                    <th>Počet evidenčných listov</th>
                                    <th>Počet skladov</th>
                                    <th>Počet nádob</th>
                                    <th>Akcie</th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(branches) && branches.length === 0 && (
                                    <tr>
                                        <td colSpan={5} className="text-center text-muted py-5">
                                            <p className="mb-1"><strong>Zatiaľ nemáte žiadnu prevádzku.</strong></p>
                                            <p className="mb-0">Kliknutím na tlačidlo <em>Pridať prevádzku</em> vytvoríte prvú prevádzku.</p>
                                        </td>
                                    </tr>
                                )}
                                {Array.isArray(branches) && branches.map((branch) => (
                                    <tr key={branch._id}>
                                        <td className="px-3">{branch.name}</td>
                                        <td>{branch.evidenceSheets.length}</td>
                                        <td>{branch.warehouse.length}</td>
                                        <td>{branch.container.length}</td>                         
                                        <td> 

                                            {/* Edit Icon */}
                                            <Button
                                                className="btnIcon"
                                            >
                                                <OverlayTrigger placement="top" overlay={renderTooltipEdit}>
                                                    <EditIcon
                                                        onClick={() => handleEditButtonClick(branch._id)}
                                                        alt="Upraviť"
                                                        className="icon icon-edit"
                                                    />
                                                </OverlayTrigger>
                                            </Button>

                                            {/* Remove Icon */}
                                      
                                                <OverlayTrigger 
                                                    placement="top" 
                                                    overlay={
                                                        branches.length <= 1
                                                            ? renderTooltipCannotRemoveLastBranch()
                                                            : branch.evidenceSheets.length > 0
                                                            ? renderTooltipCannotRemoveWithEvidence()
                                                            : branch.warehouse.length > 0
                                                            ? renderTooltipCannotRemoveWithWarehouse()
                                                            : branch.container.length > 0
                                                            ? renderTooltipCannotRemoveWithContainer()
                                                            : renderTooltipRemove
                                                    }
                                                >
                                                    <div className="icon">
                                                        <Button
                                                            className="btnIcon"
                                                            disabled={branches.length <= 1 || branch.evidenceSheets.length > 0 || branch.warehouse.length > 0 || branch.container.length > 0}
                                                        >
                                                            <RemoveIcon
                                                                onClick={() => handleRemoveButtonClick(branch._id, branch.name)}
                                                                alt=""
                                                                className="icon icon-remove"
                                                            />
                                                        </Button>
                                                    </div>
                                                </OverlayTrigger>
                                        

                                        </td>
                                    </tr>
                                    ))}
                            </tbody>
                        </Table>
                    </div>

                </div>
            }

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Potvrdenie</Modal.Title>
                </Modal.Header>
                
                <Modal.Body>
                    Naozaj chcete vymazať prevádzku <b>{branchNameToDelete}</b>? 
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Zrušiť
                    </Button>
                    <Button variant="danger" onClick={handleDeleteBranch}>
                        Vymazať
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Custom modal to adding branch */}
            <CustomModal isVisible={isAddModalVisible} onClose={handleCloseAddModal}>
                <AddBranch onClose={handleCloseAddModal} />
            </CustomModal>

            {/* Custom modal to editing branch */}
            <CustomModal isVisible={isEditModalVisible} onClose={handleCloseEditModal}>
            { 
                branchToEdit && isEditModalVisible ? 
                    <EditBranch branchId={branchToEdit} onClose={handleCloseEditModal} />
                    : null
            }
            </CustomModal>

        </>
    )
}

export default ShowBranches;